<template>
    <span :class="['event-linked', { complete: isComplete}]" v-if="filteredSchedule.length > 0">
        Event : 
        <span v-for="(schedule, index) in filteredSchedule"
            :key="index"
            class="schedule">
                {{ index > 0 ? ', ' : '' }}
                <b>
                    {{ getContentKey('event', schedule.event, 'name') }}
                </b>
                ({{ formatDate(schedule.time) }})
        </span>
    </span>
</template>

<script>
import { mapGetters } from 'vuex'
import formatDate from '@/module/util/format-date'
export default {
    name: 'event-list',

    props: {
        patient: {
            type: Object,
            required: true
        },
        surveyData: {
            type: Object
        }
    },


    computed: {
        ...mapGetters('content', [ 'getContentKey' ]),
        ...mapGetters('provider', [
            'getPatientSchedule'
        ]),
        patientSchedule() {
            return this.getPatientSchedule(this.patient.id)
        },
        filteredSchedule() {
            if(this.surveyData.event) {
                const messageIdList = this.surveyData.event.flatMap((event) => event.message)
                return this.patientSchedule.filter(({ message }) => messageIdList.some((messageId) => message.includes(messageId)))
            }
            return []
        },
    
        isComplete() {
            return this.surveyData.event.every((event) => event.completed)
        }
    },

    methods: {
        formatDate
    }
}
</script>

<style lang="scss" scoped>
.event-linked {
    display: block;
    font-size: 14px;
    line-height: 18px;
    padding: 3px 8px 3px 20px;
    background: #eeeeee;
    &.complete {
        color: #60a213;
        background: transparent;
    }
    b {
        font-weight: 600;
    }
}
</style>